// See: https://stackoverflow.com/questions/492994/compare-two-dates-with-javascript
// Source: http://stackoverflow.com/questions/497790

import { formatNum } from "./format";

// We create 2 formatters
const ShortDateFormat = new Intl.DateTimeFormat("en", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});
const ShortTimeFormat = new Intl.DateTimeFormat("en", {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h24",
});

export const Dates = {
  convert: function (d: any) {
    // Converts the date in d to a date-object. The input can be:
    //   a date object: returned without modification
    //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
    //   a number     : Interpreted as number of milliseconds
    //                  since 1 Jan 1970 (a timestamp)
    //   a string     : Any format supported by the javascript engine, like
    //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
    //  an object     : Interpreted as an object with year, month and date
    //                  attributes.  **NOTE** month is 0-11.
    return d.constructor === Date
      ? d
      : d.constructor === Array
        ? new Date(d[0], d[1], d[2])
        : d.constructor === Number
          ? new Date(d as number)
          : d.constructor === String
            ? new Date(d.toString())
            : typeof d === "object"
              ? new Date(d.year, d.month, d.date)
              : NaN;
  },

  compare: function (a: any, b: any) {
    // Compare two dates (could be of any type supported by the convert
    // function above) and returns:
    //  -1 : if a < b
    //   0 : if a = b
    //   1 : if a > b
    // NaN : if a or b is an illegal date
    // NOTE: The code inside isFinite does an assignment (=).
    return isFinite((a = this.convert(a).valueOf())) && isFinite((b = this.convert(b).valueOf())) ? (a > b ? 1 : 0) - (a < b ? 1 : 0) : NaN;
  },

  inRange: function (d: any, start: any, end: any) {
    // Checks if date in d is between dates in start and end.
    // Returns a boolean or NaN:
    //    true  : if d is between start and end (inclusive)
    //    false : if d is before start or after end
    //    NaN   : if one or more of the dates is illegal.
    // NOTE: The code inside isFinite does an assignment (=).
    return isFinite((d = this.convert(d).valueOf())) && isFinite((start = this.convert(start).valueOf())) && isFinite((end = this.convert(end).valueOf())) ? start <= d && d <= end : NaN;
  },

  toDateTimeStr: function (d: Date): string {
    return `${ShortDateFormat.format(d)} ${ShortTimeFormat.format(d)}`;
  },

  getMonthBased1: function (d: Date): number {
    return d.getMonth() + 1;
  },

  toTimestampStr: function (d: Date): string {
    const date = `${d.getFullYear()}${formatNum(this.getMonthBased1(d), 2)}${formatNum(d.getDate(), 2)}`;
    const time = `${formatNum(d.getHours(), 2)}${formatNum(d.getMinutes(), 2)}${formatNum(d.getSeconds(), 2)}`;

    return `${date}_${time}`;
  },
};
